import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { AnalysisStatus } from '@/api/domains/analyses/types';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  statusFilter: AnalysisStatus | 'all';
  onClearFilter?: () => void;
}

export const EmptyState = ({
  statusFilter,
  onClearFilter
}: EmptyStateProps) => {
  const navigate = useNavigate();

  if (statusFilter === 'all') {
    return (
      <div className={styles.emptyState}>
        <i className="pi pi-inbox" />
        <h3>No analyses yet</h3>
        <p>Create your first document comparison analysis</p>
        <Button
          variant="contained"
          onClick={() => navigate('/analyses/create')}
          className={styles.createButton}
        >
          Create Analysis
        </Button>
        <i className="pi pi-filter" />
        <h3>No {statusFilter.toLowerCase()} analyses</h3>
        <p>No analyses found with status: {statusFilter}</p>
        <Button
          variant="outlined"
          onClick={onClearFilter}
          className={styles.clearFilterButton}
        >
          Clear Filter
        </Button>
      </div>
    );
  }
};
